import * as React from 'react'

import type {
  DraggableAttributes,
  DraggableSyntheticListeners,
} from '@dnd-kit/core'

export type ColumnDragContextType = {
  dragging: boolean
  draggable: boolean
  setNodeRef: (node: HTMLElement | null) => void
  setActivatorNodeRef: (element: HTMLElement | null) => void
  style: React.CSSProperties
  listeners: DraggableSyntheticListeners
  attributes: DraggableAttributes
}

export const ColumnDragContext = React.createContext<
  ColumnDragContextType | undefined
>(undefined)

export const useDraggableColumn = (): ColumnDragContextType => {
  const context = React.useContext(ColumnDragContext)
  if (context === undefined) {
    throw new Error(
      'useDraggableColumn must be used within a ColumnDragContextProvider',
    )
  }
  return context
}
